import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'La collezione completa in 6 volumi + 5 bonus per capire il vino dalla vigna al bicchiere.';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'it';
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nvst52eusjuw">
      <MetaPixel data-id="element-1" data-mp="su445ggvx0ep" />
      <main data-id="element-2" data-mp="stko65asom3b">
        <Hero data-id="element-3" data-mp="stccggqermtp" />
        <LookInsideCarousel data-id="element-4" data-mp="ssss6tdacmci" />
        <ProblemSection data-id="element-5" data-mp="36hvn4muyo06" />
        <SystemSection data-id="element-6" data-mp="35ox2qy1z4t4" />
        <ModulesSection data-id="element-7" data-mp="34x1vh8db93d" />
        <BonusSection data-id="element-8" data-mp="38kvshhq5xim" />
        <UrgencySection data-id="element-9" data-mp="3ud1glcmeruc7" />
        <PricingSection data-id="element-10" data-mp="3udkqq75thefo" />
        <GuaranteeSection data-id="element-11" data-mp="3uc9i9u1ffii8" />
        <FAQ data-id="element-12" data-mp="3uf5gzkl3mb7q" />
        <ClosingSection data-id="element-13" data-mp="d4e6dvbvvgxr" />
        <SummaryTable data-id="element-14" data-mp="d4xlz5e29t8m" />
        <FinalCta data-id="element-15" data-mp="d45sq17xs7li" />
      </main>
      <Footer data-id="element-16" data-mp="d2bhjemgvtum" />
      <PurchaseNotification data-id="element-17" data-mp="85uivqhn5x3a" />
    </div>;
}